/*
 * AuthReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import { fromJS } from 'immutable';

import { CHANGE_CARD_SUCCESS, CHANGE_CONTRACT_SUCCESS, SUBSCRIPTION_STOP_SUCCESS, SUBSCRIPTION_REACTIVATE_SUCCESS } from 'containers/ContractPage/constants';

import { FETCH_ME_REQUEST, FETCH_ME_SUCCESS, FETCH_ME_FAILURE, STATE_RESET, LOADING, CHANGE_ME_FAILURE, CHANGE_ME_SUCCESS } from './constants';

// The initial state of the App
const initialState = fromJS({
  loading: false,
  error: false,
  authenticated: false,
  user: {},
  changeErrors: [],
});


function authReducer(state = initialState, action) {
  // const user = state.get('user').toJS();

  switch (action.type) {
    case STATE_RESET:
      return state.merge(initialState);
    case FETCH_ME_REQUEST:
      return state.merge({ authenticated: true, loading: true, error: false });
    case FETCH_ME_SUCCESS:
      return state.merge({
        authenticated: true,
        loading: false,
        error: false,
        user: action.payload.user,
      });
    case FETCH_ME_FAILURE:
      return state.merge({ authenticated: false, loading: false, error: true });
    case LOADING:
      return state.merge({ loading: action.value, changeErrors: fromJS([]) });
    case CHANGE_ME_SUCCESS:
    case CHANGE_CARD_SUCCESS:
    case CHANGE_CONTRACT_SUCCESS:
    case SUBSCRIPTION_STOP_SUCCESS:
    case SUBSCRIPTION_REACTIVATE_SUCCESS:
      return state.merge({
        authenticated: true,
        loading: false,
        error: false,
        user: action.payload.user,
        changeErrors: fromJS([]),
      });
    case CHANGE_ME_FAILURE:
      return state.merge({ loading: false, changeErrors: fromJS(action.errors) });
    default:
      return state;
  }
}

export default authReducer;
